import { memo } from "react";

import { Wrapper } from "./Wrapper";

export const Loading = memo(() => (
  <Wrapper>
    <img src="/padre-loading.gif" height={26} alt="loading..." />
  </Wrapper>
));
